import React,{Fragment} from 'react';
import NewTabletOrderItem from './NewTabletOrderItem';

const NewTabletOrderItemBlock = (props) => {

    const renderOrders = () => (
        props.list ? 
            props.list.map(card=>(
                <NewTabletOrderItem
                    key={card._id}
                    handelOnClickTabletNewOrder={props.handelOnClickTabletNewOrder}
                    {...card}
                />
            ))
        :null
    )

    return (
        <Fragment>
            {props.list ?
                props.list.length === 0 ?
                    <tr className="no_result text-center">
                       <td colSpan="4"> No orders have been placed. </td>
                    </tr>
                :null
            :null}
            { renderOrders(props.list)}

        </Fragment>
    );
};

export default NewTabletOrderItemBlock;